import React from "react";
import { Field, Input, Textarea, Select, SectionTitle, Card } from "./_shared";
import { X, Plus } from "lucide-react";

export default function FooterEditor({ value, onChange }) {
  const set = (k, v) => onChange({ ...value, [k]: v });
  const setUnit = (i, patch) => {
    const units = value.units.map((u, idx) => idx === i ? { ...u, ...patch } : u);
    onChange({ ...value, units });
  };
  const addUnit = () => onChange({ ...value, units: [...value.units, { label: "Nuevo", href: "/", color: "muted" }] });
  const removeUnit = (i) => onChange({ ...value, units: value.units.filter((_, idx) => idx !== i) });

  return (
    <div>
      <SectionTitle title="Footer" subtitle="Pie de página global" />
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <Field label="Tagline"><Input value={value.tagline} onChange={(e) => set("tagline", e.target.value)} /></Field>
        <Field label="Email"><Input value={value.email} onChange={(e) => set("email", e.target.value)} /></Field>
        <Field label="Teléfono"><Input value={value.phone} onChange={(e) => set("phone", e.target.value)} /></Field>
        <Field label="Ubicación"><Input value={value.location} onChange={(e) => set("location", e.target.value)} /></Field>
        <div className="md:col-span-2">
          <Field label="Descripción"><Textarea rows={3} value={value.description} onChange={(e) => set("description", e.target.value)} /></Field>
        </div>
        <Field label="Copyright"><Input value={value.copyright} onChange={(e) => set("copyright", e.target.value)} /></Field>
        <Field label="Hecho con..."><Input value={value.made_in} onChange={(e) => set("made_in", e.target.value)} /></Field>
      </div>

      <Card className="mt-6">
        <div className="flex items-center justify-between mb-4">
          <h3 className="font-display text-xl">Links de unidades</h3>
          <button onClick={addUnit} className="inline-flex items-center gap-1 text-xs text-white/60 hover:text-white transition-colors">
            <Plus className="w-3 h-3" /> Añadir
          </button>
        </div>
        <div className="space-y-2">
          {value.units.map((u, i) => (
            <div key={i} className="grid grid-cols-1 md:grid-cols-[1fr_1fr_140px_40px] gap-2">
              <Input value={u.label} onChange={(e) => setUnit(i, { label: e.target.value })} placeholder="Etiqueta" />
              <Input value={u.href} onChange={(e) => setUnit(i, { href: e.target.value })} placeholder="/ruta" />
              <Select value={u.color || "muted"} onChange={(e) => setUnit(i, { color: e.target.value })}>
                <option value="orange">Naranja</option>
                <option value="teal">Teal</option>
                <option value="muted">Neutro</option>
              </Select>
              <button onClick={() => removeUnit(i)} className="w-10 h-10 rounded-lg border border-white/10 hover:border-red-500/40 text-white/50 hover:text-red-400 flex items-center justify-center transition-colors">
                <X className="w-4 h-4" />
              </button>
            </div>
          ))}
        </div>
      </Card>
    </div>
  );
}
